













































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import OrderItem from "../../logic/model/OrderItem";
import Article from "../../logic/model/Article";
import ApiConnector from "../../logic/connector/ApiConnector";
import PizzaIcon from '../components/PizzaIcon.vue'
import StarorderProgress from '../components/StarorderProgress.vue';
import _ from 'lodash';


@Component({
    components: {
        StarorderProgress,PizzaIcon
    },
    name: "today-view"
})
export default class TodayView extends Vue{



        get starorderCount() {
            return this.$store.state.order.starOrders.length;
        }
        get starorderGroups() {
            let groups:Array<any> = [];
            let starorders:Array<Array<OrderItem>> = _.chunk(this.$store.state.order.starordersByPrice,7);


            starorders.forEach( (starorder:Array<OrderItem>) => {
                if (starorder.length === 7) {
                    groups.push(this.groupOrders(starorder));
                }
            });

            return groups;
        }
        get orders() {
            return this.$store.state.order.getRegularOrders();
        }
        get progress() {
            let starorders = this.$store.state.order.starOrderCandidates;
            if (starorders.length === 0) {
                return 0;
            }

            if (starorders.length % 7 === 0) {
                return 7;
            }

            return starorders.length % 7;

        }
        get groupedOrders() {
            let result = _(this.orders)
                .groupBy((x:OrderItem) => x.$article.$name)
                .map((value, key) => ({title: key, orders: value}))
                .value();
            return result;

        }



        groupOrders(orders:Array<OrderItem>) {

            let result = _(orders)
                .groupBy((x:OrderItem) => x.$article.$name)
                .map((value, key) => ({title: key, orders: value}))
                .value();
            return result;

        }
        getIcon(article:Article) {
            if (article.$description) {
                let loweredIngredients = article.$description.toLowerCase();
                if (loweredIngredients.includes('salami')) {
                    return 'salami-svgrepo-com'
                } else if (loweredIngredients.includes('ananas')) {
                    return 'pineapple'
                } else if (loweredIngredients.includes('schinken')) {
                    return 'ham'
                } else if (loweredIngredients.includes('thunfisch')) {
                    return 'tuna'

                } else if (loweredIngredients.includes('hähnchenfleisch')) {
                    return 'spaguetti'
                } else if (loweredIngredients.includes('käse')) {
                    return 'cheese'
                } else {
                    return 'pizza'
                }
            } else {
                return 'pizza'
            }

        }
        pay(order:OrderItem) {
            new ApiConnector().patch('/api/order/' + order.$id, {
                'payed': true
            })

        }
        cancel(order:OrderItem) {
            new ApiConnector().patch('/api/order/' + order.$id, {
                'payed': false
            })

        }

}
